import { Property } from '@bbraun/bav-reporting/ui-report-editor';
import { IS_GREATER_OR_EQUAL_NUMBER_ID } from '../../../../validation/factories/is-greater-or-equal-number-validator-factory';
import { IS_NUMBER_ID } from '../../../../validation/factories/is-number-validator-factory';

export function createScoreSumPerPatientProperty(): Property {
  return {
    title: 'TOTAL SCORE SUM/PATIENTS ',
    technicalName: 'census_n21',
    dataType: 'calculated',
    unit: null,
    highlighted: false,
    subName: null,
    formula: 'census_l19 / census_m19',
    validation: [
      { validator: IS_NUMBER_ID },
      {
        validator: IS_GREATER_OR_EQUAL_NUMBER_ID,
        options: {
          config: {
            minimum: 0,
          },
        },
      },
    ],
  };
}
